import RouterSection from '@/Layout/components/RouterSection';

export default {
  path: '/ggoods',
  name: 'ggoods_home',
  component: RouterSection,
  mode: 'history',
  children: [
    {
      path: 'detail',
      name: 'detail',
      component: () => import('@/views/ggoods/GgoodsDetail'),
      meta: { noCache: true },
    },
  ],
};
